import { noop } from 'underscore';

export default {
  handler: 'openMenu',
  data: noop,
};
